export const ConnectorAuthSaveAs = {
    DoNotSave: 0,
    PerUser: 1,
    Shared: 2,
};
/** @typedef {typeof ConnectorAuthSaveAs[keyof typeof ConnectorAuthSaveAs]} ConnectorAuthSaveAs */

export const ConnectorAuthFieldType = {
    String: 1,
    Password: 2,
    Enum: 3,
    Checkbox: 4,
    File: 5,
};
/** @typedef {typeof ConnectorAuthFieldType[keyof typeof ConnectorAuthFieldType]} ConnectorAuthFieldType */

export const ConnectorAuthSettingType = {
    Constant: 0,
    User: 1,
    Authenticated: 2,
};
/** @typedef {typeof ConnectorAuthSettingType[keyof typeof ConnectorAuthSettingType]} ConnectorAuthSettingType */

export const ConnectorAuthStatus = {
    Development: 0,
    Active: 1,
    Deprecated: 3,
};
/** @typedef {typeof ConnectorAuthStatus[keyof typeof ConnectorAuthStatus]} ConnectorAuthStatus */

export const AuthenticationType = {
    None: 0,
    OAuth2AuthorizationCode: 1,
    OAuth2ClientCredentials: 2,
    Basic: 3,
    Ntlm: 4,
    ExchangeToken: 5,
    BearerToken: 6,
    OAuth2Password: 8,
    ApiKey: 9,
};
/** @typedef {typeof AuthenticationType[keyof typeof AuthenticationType]} AuthenticationType */
